import React from 'react'
import plant from '../images/plant.png'
import Overlay from './Overlay'

function ActivityIndicator(props) {
	const cHeight = (props.showActivityIndicator)? "100%": "100%"
	// const cHeight = (props.showActivityIndicator)? "100%": "0%"
	const c = <div>
		<img src={plant} id="plant-grow" alt="Activity Indicator" />
		<div className="loading">Loading</div>
	</div>
	return (<div className="activity-indicator">
		<Overlay content={c} cHeight={cHeight} />
	</div>)
}

export default ActivityIndicator
